import Bajaj from 'src/assets/AddedServices/Bajaj-Allianz-Life-Insurance-Logo.svg'
import Health from 'src/assets/AddedServices/aditya-birla-capitalL.svg'
import Care from 'src/assets/AddedServices/care_health_insurance_logo.svg'
import lifeInsurance from 'src/assets/AddedServices/Marriage/LifeInsurance.svg'
import homeLoanInsurance from 'src/assets/AddedServices/Marriage/HomeLoanInsurance.svg'
import motorInsurance from 'src/assets/AddedServices/Marriage/MotorInsurance.svg'
import healthInsurance from 'src/assets/AddedServices/Marriage/HealthInsurance.svg'

const InsurancePlansList = [
  {
    insuranceImage: Health,
    insuranceName: 'Aditya Birla Activ Fit Plan',
    insuranceFeatures: [
      'Coverage for normal delivery and C-section delivery are available',
      'Pre-natal and post-natal expenses are covered',
      'Newborn baby treatment and vaccination expenses are covered',
      'Stem cell preservation cover is also available',
    ],
  },
  {
    insuranceImage: Bajaj,
    insuranceName: 'Bajaj Allianz Health Guard Plan',
    insuranceFeatures: [
      'Normal and caesarean deliveries are covered',
      'Coverage for pre-natal and post-natal expenses are available',
      'Post-delivery complications are covered',
      'Newborn baby cover is also available',
      'Lawful termination of pregnancy is also covered',
    ],
  },
  {
    insuranceImage: Care,
    insuranceName: 'Care Joy Maternity Insurance Plan',
    insuranceFeatures: [
      'Coverage for maternity expenses are available',
      'Pre-natal expenses and post-natal expenses are covered',
      'Newborn baby cover is available',
      'Treatment for newborn baby defects is also covered',
      'No pre-policy medical check-up is required',
    ],
  },
]

const InsurancePolicies = [
  {
    id: 1,
    name: 'Health Insurance',
    image: healthInsurance,
    coverageText: 'Essential for both partners. The coverage could be',
    coverageBoldText: 'INR 5-10 lakhs.',
    link: `${process.env.REACT_APP_LANDING_URL}/individual/dashboard/buyPolicy/health`,
  },
  {
    id: 2,
    name: 'Life Insurance',
    image: lifeInsurance,
    coverageText:// prettier-ignore
     'Secures your spouse\'s future. Choose coverage around',
    coverageBoldText: 'ten times your annual income.',
    link: `${process.env.REACT_APP_HOME_URL}/term-life-insurance/`,
  },
  // {
  //   id: 3,
  //   name: 'Personal Accident',
  //   image: personalInsurance,
  //   coverageText: 'Covers disability or death. Coverage ranges from',
  //   coverageBoldText: 'INR 10-25 lakhs.',
  // },
  {
    id: 4,
    name: 'Home Loan Insurance',
    image: homeLoanInsurance,
    coverageText:
      'Protects your home loan liability in case of unforeseen events.',
    coverageBoldText: '',
    link: `${process.env.REACT_APP_HOME_URL}/home-insurance/`,
  },
  {
    id: 5,
    name: 'Motor Insurance',
    image: motorInsurance,
    coverageText:
      'Ensures protection against accidents and theft as per Motor Vehicles Act.',
    coverageBoldText: '',
    link: `${process.env.REACT_APP_LANDING_URL}/individual/dashboard/buyPolicy/motor`,
  },
]

const DashboardEmailsEnums = {
  CLAIM_REQUEST: 'CLAIM_REQUEST',
  MATERNITY_ENQUIRY: 'MATERNITY_ENQUIRY',
  FINANCIAL_SECURITY: 'FINANCIAL_SECURITY',
  NEW_CAR_ENQUIRY: 'NEW_CAR_ENQUIRY',
}

const CONTACT_FORM_ERROR_MESSAGES = {
  NAME_REQUIRED: 'Name is required.',
  PHONE_REQUIRED: 'Phone is required.',
  INSURANCE_TYPE_REQUIRED: 'Insurance Type is required.',
  QUERY_REQUIRED: 'Query is required.',
  PREFERRED_TIME_REQUIRED: 'Preferred time is required.',
  VALID_NAME: 'Please enter a valid Name.',
  VALID_PHONE: 'Please enter a valid Phone number.',
  VALID_EMAIL: 'Please Enter a valid E-mail',
  SCHEDULED_TIME: 'Time Schedule is required.',
  VEHICLE_DETAILS_REQUIRED: 'Vehicle Details are required.',
  EMAIL_REQUIRED: 'E-mail is required.',
  VEHICLE_NUMBER: 'Vehicle Number is required',
  VEHICLE_MODAL: 'Vehicle Model is required',
  VALID_VEHICLE_NUMBER: 'Please enter a valid Vehicle Number',
}

export {
  InsurancePlansList,
  InsurancePolicies,
  DashboardEmailsEnums,
  CONTACT_FORM_ERROR_MESSAGES,
}
